import { cn } from "@/lib/utils";
import { ErrorHeader } from "./ErrorHeader";
import { ErrorLocation } from "./ErrorLocation";
import { XIcon } from "lucide-react";
import { useState } from "react";

interface ErrorContentProps {
  message?: string;
  filename?: string;
  lineno?: number;
  colno?: number;
  stack?: string;
  onClose?: () => void;
}

export function ErrorContent({
  message = "An error occurred",
  filename = "unknown",
  lineno = 1,
  colno = 1,
  stack,
  onClose,
}: ErrorContentProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={cn(
        "w-full max-w-[900px] rounded-md overflow-hidden pointer-events-auto select-text relative cursor-default",
        isExpanded && "bg-secondary-n-900",
      )}
    >
      <XIcon
        className={cn(
          "absolute top-1 right-1 w-6 h-6 cursor-pointer text-secondary-n-200 hover:text-white",
          onClose ? "opacity-100" : "opacity-0 pointer-events-none",
        )}
        onClick={onClose}
      />
      <ErrorHeader
        message={message}
        isExpanded={isExpanded}
        setIsExpanded={() => setIsExpanded((prev) => !prev)}
      />
      {isExpanded && (
        <div>
          <ErrorLocation filename={filename} lineno={lineno} colno={colno} />

          {stack && (
            <div className="p-2 font-mono text-2xs text-secondary-n-50 overflow-x-auto rounded-bl-md rounded-br-md whitespace-pre-wrap wrap-break-word border border-secondary-300 shrink-0 leading-normal">
              {stack}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ErrorContent;
